import React from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import Solutions from "./Discover"
import DigitalAssets from "./slider";
import Commitment from "./OTCStep";
import Footer from "../Components/Footer";
import CTASection from "../AboutUs/CtaSection";
import FAQ from "./FAQ";


function TennetHome() {
  return (
    <div>
      <main>
        <Header />
        <HeroSection />
        <Solutions />
        <Commitment />
        {/* <DigitalAssets /> */}
        {/* <DeploymentSection /> */}
        <CTASection />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
